import DumbComponent from './dumb.js';
import enhance from './enhancer';

export default enhance(DumbComponent);
